import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { COOKIES } from '@/services/constants';

const reverseHelpCenterUrl = 'https://help.reverse.health/';
const muscleChargeHelpCenterUrl = 'https://intercom.help/musclecharge/';

export default function ({ $cookies, app }, inject) {
  const getHelpCenterUrl = () => {
    const langCookies = $cookies.get(COOKIES.lang) || null;
    const usedLocale = app.i18n.locales.find((locale) => locale.code === app.i18n.locale);
    const lang = usedLocale ? usedLocale.acceptedLanguage.substring(0, 2) : null;

    const brand = app.store.state.brand.brand;
    const helpCenterUrl = brand === PROJECT_BRANDS.muscleCharge ? muscleChargeHelpCenterUrl : reverseHelpCenterUrl;

    return lang ? `${helpCenterUrl}${lang}` : langCookies ? `${helpCenterUrl}${langCookies}` : helpCenterUrl;
  };

  inject('getHelpCenterUrl', getHelpCenterUrl);
}
